export const main = '#421b9b';
export const secondary = '#5955d9';
export const third = '#f25e6b';
export const grisObscuro = '#808080';
export const normal = '#222831';
export const background = '#ffffff';
